<template>
  <div class="user-manage">
    <el-card>
      <div slot="header">
        <span>账号管理</span>
        <el-button type="success" size="small" style="float:right;margin-left:8px" @click="showInviteDialog" v-if="isSubAdmin">邀请链接</el-button>
        <el-button type="primary" size="small" style="float:right" @click="openAdd(null)" v-if="isSubAdmin || isSuperAdmin">创建账号</el-button>
      </div>

      <div v-loading="loading">
        <div v-if="treeData.length === 0" style="text-align:center;padding:40px;color:#999">暂无数据</div>
        <template v-else>
          <div class="tree-header">
            <span class="th-icon"></span>
            <span class="th-name">账号</span>
            <span class="th-tag">代理/分组</span>
            <span class="th-role">角色</span>
            <span class="th-perm">权限</span>
            <span class="th-video">绑定视频号</span>
            <span class="th-time">创建时间</span>
            <span class="th-action">操作</span>
          </div>
          <div v-for="node in treeData" :key="node.id">
            <user-node
              :node="node"
              :is-super-admin="isSuperAdmin"
              @delete="handleDeleteUser"
              @toggle="handleToggleStatus"
              @edit="openEdit"
              @add-child="openAdd"
              @query-revenue="handleQueryRevenue"
              @refresh="loadTree"
            />
          </div>
        </template>
      </div>
    </el-card>

    <el-dialog title="创建账号" :visible.sync="showDialog" width="450px">
      <el-form ref="userForm" :model="userForm" :rules="userRules" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="userForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="userForm.nickname"></el-input>
        </el-form-item>
        <el-form-item v-if="parentNickname" label="上级账号">
          <el-tag type="info">{{ parentNickname }}</el-tag>
        </el-form-item>
        <el-form-item label="角色" prop="roleType" v-if="isSuperAdmin && !parentId">
          <el-select v-model="userForm.roleType" style="width:100%">
            <el-option label="分后台（可管理）" value="SUB_ADMIN"></el-option>
            <el-option label="查询用户" value="USER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可导入数据" v-if="isSuperAdmin && userForm.roleType === 'SUB_ADMIN'">
          <el-switch v-model="userForm.canImport" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="可导入数据" v-if="isSubAdmin">
          <el-switch v-model="userForm.canImport" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="收益权限">
          <el-select v-model="userForm.incomePermission" style="width:100%">
            <el-option label="总收益 + 分成后收益" value="BOTH"></el-option>
            <el-option label="仅总收益" value="ONLY_TOTAL"></el-option>
            <el-option label="仅分成后收益" value="ONLY_AFTER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属团队分组">
          <el-select v-model="userForm.groupId" placeholder="可不选" clearable style="width:100%" @change="onCreateGroupChange">
            <el-option v-for="g in groupList" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属剧场" v-if="userForm.roleType === 'SUB_ADMIN'">
          <el-select v-model="userForm.theaterIds" multiple placeholder="请选择剧场" style="width:100%">
            <el-option v-for="t in theaterAllList" :key="t.id" :label="t.name" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定视频号">
          <div>
            <el-tag v-for="(vid,idx) in userForm.videoIds" :key="idx" closable @close="removeVideo(idx)" style="margin-right:5px;margin-bottom:5px">{{ vid }}</el-tag>
            <el-input v-if="videoInputVisible" ref="videoInput" v-model="videoInputValue" size="small" style="width:140px" placeholder="sph开头" @keyup.enter.native="addVideo" @blur="addVideo" @input="onVideoInput"></el-input>
            <el-button v-else size="small" @click="showVideoInput">+ 添加视频号</el-button>
          </div>
          <span class="form-tip">只能输入sph开头的视频号ID</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="handleCreate">确认创建</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑账号" :visible.sync="showEditDialog" width="450px">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="editForm.nickname"></el-input>
        </el-form-item>
        <el-form-item label="所属上级">
          <el-select v-model="editForm.parentId" placeholder="可不选（清空上级）" clearable style="width:100%">
            <el-option v-for="p in parentCandidates" :key="p.id" :label="p.nickname || p.username" :value="p.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="editForm.password" type="password" placeholder="留空不修改"></el-input>
        </el-form-item>
        <el-form-item label="可导入数据" v-if="isSuperAdmin || isSubAdmin">
          <el-switch v-model="editForm.canImport" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="收益权限">
          <el-select v-model="editForm.incomePermission" style="width:100%">
            <el-option label="总收益 + 分成后收益" value="BOTH"></el-option>
            <el-option label="仅总收益" value="ONLY_TOTAL"></el-option>
            <el-option label="仅分成后收益" value="ONLY_AFTER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属团队分组">
          <el-select v-model="editForm.groupId" placeholder="可不选" clearable style="width:100%" @change="onEditGroupChange">
            <el-option v-for="g in groupList" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属剧场" v-if="editFormRoleType === 'SUB_ADMIN'">
          <el-select v-model="editForm.theaterIds" multiple placeholder="请选择剧场" style="width:100%">
            <el-option v-for="t in theaterAllList" :key="t.id" :label="t.name" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定视频号">
          <div>
            <el-tag v-for="(vid,idx) in editForm.videoIds" :key="idx" closable @close="removeEditVideo(idx)" style="margin-right:5px;margin-bottom:5px">{{ vid }}</el-tag>
            <el-input v-if="editVideoInputVisible" ref="editVideoInput" v-model="editVideoInputValue" size="small" style="width:140px" placeholder="sph开头" @keyup.enter.native="addEditVideo" @blur="addEditVideo" @input="onEditVideoInput"></el-input>
            <el-button v-else size="small" @click="showEditVideoInput">+ 添加视频号</el-button>
          </div>
          <span class="form-tip">只能输入sph开头的视频号ID</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEditDialog = false">取消</el-button>
        <el-button type="primary" @click="handleEdit">确认修改</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'用户收益 - ' + revenueUserName" :visible.sync="showRevenueDialog" width="90%" top="5vh">
      <div v-loading="revenueLoading">
        <div v-if="revenueSummary" class="revenue-section">
          <div class="revenue-header">收益概览</div>
          <el-row :gutter="12">
            <el-col :span="6" v-for="card in revenueCards" :key="card.key">
              <div class="revenue-card">
                <div class="revenue-card-label">{{ card.label }}</div>
                <div class="revenue-card-value" :style="{ color: card.color || '#333' }">{{ card.value }}</div>
              </div>
            </el-col>
          </el-row>
          <div class="revenue-tip">* 总收益为计算分成后的收益</div>
        </div>

        <div style="display:flex;justify-content:space-between;align-items:center;margin:16px 0 12px 0">
          <div class="revenue-header" style="margin:0;padding:0;border:none">数据列表</div>
          <div>
            <el-button type="text" size="small" @click="revExpandAll">展开全部</el-button>
            <el-button type="text" size="small" @click="revCollapseAll">折叠全部</el-button>
          </div>
        </div>
        <div v-if="!revenueLoading && revenueGroupedData.length === 0" style="text-align:center;padding:40px;color:#999">暂无数据</div>
        <div v-for="group in revenueGroupedData" :key="group.videoId" class="video-group">
          <el-table :data="[{ summary: {} }]" :border="false" :show-header="false" style="width:100%">
            <el-table-column :span="10">
              <template>
                <div class="group-header" @click="revToggleExpand(group.videoId)">
                  <div class="group-left">
                    <i class="expand-icon" :class="{ expanded: revenueExpandedRows.includes(group.videoId) }"></i>
                    <span class="group-video-id">{{ group.videoId }}</span>
                    <span class="group-video-nickname">{{ group.videoNickname }}</span>
                    <span v-if="group.theaters && group.theaters.length > 0" class="group-theaters">
                      <el-tag v-for="(theater, idx) in group.theaters" :key="idx" size="mini" type="info">{{ theater }}</el-tag>
                    </span>
                    <span class="group-count">({{ group.count }}条)</span>
                  </div>
                  <div class="group-summary">
                    <span class="summary-item">视频播放量: <strong>{{ toInt(group.totalVideoPlayCount) }}</strong></span>
                    <span class="summary-item">剧集播放量: <strong>{{ toInt(group.totalDramaPlayCount) }}</strong></span>
                    <span class="summary-item income">总收益: <strong>{{ toFixed2(group.totalAfterIncome) }}</strong></span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div v-show="revenueExpandedRows.includes(group.videoId)" class="group-detail" v-loading="revIsGroupLoading(group.videoId)">
            <el-table :data="revGetGroupRecords(group.videoId)" :border="false" style="width:100%">
              <el-table-column prop="recordDateRange" label="日期范围" width="150" show-overflow-tooltip>
                <template slot-scope="scope"><span class="table-text">{{ scope.row.recordDateRange }}</span></template>
              </el-table-column>
              <el-table-column prop="theaterName" label="剧场" width="100" show-overflow-tooltip>
                <template slot-scope="scope"><span class="table-text">{{ scope.row.theaterName }}</span></template>
              </el-table-column>
              <el-table-column prop="dramaName" label="剧目名称" width="130" show-overflow-tooltip>
                <template slot-scope="scope"><span class="table-text">{{ scope.row.dramaName }}</span></template>
              </el-table-column>
              <el-table-column prop="isMounted" label="挂载" width="60" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.isMounted === '是' ? 'success' : 'info'" size="mini">{{ scope.row.isMounted || '-' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="videoPlayCount" label="视频播放量" width="95" align="right">
                <template slot-scope="scope"><span class="table-number">{{ toInt(scope.row.videoPlayCount) }}</span></template>
              </el-table-column>
              <el-table-column prop="dramaPlayCount" label="剧集播放量" width="95" align="right">
                <template slot-scope="scope"><span class="table-number">{{ toInt(scope.row.dramaPlayCount) }}</span></template>
              </el-table-column>
              <el-table-column label="总收益" width="95" align="right">
                <template slot-scope="scope">
                  <span class="table-income">{{ toFixed2(scope.row.afterCommissionIncome != null ? scope.row.afterCommissionIncome : scope.row.adIncome) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="导入时间" width="140">
                <template slot-scope="scope"><span class="table-text">{{ (scope.row.createTime || '').replace('T', ' ') }}</span></template>
              </el-table-column>
            </el-table>
            <div v-if="group.count > 10" class="group-pagination">
              <el-pagination
                background
                layout="total, prev, pager, next, sizes"
                :total="group.count"
                :page-size="revGetGroupPageSize(group.videoId)"
                :current-page="revGetGroupCurrentPage(group.videoId)"
                :page-sizes="[10, 20, 50]"
                @current-change="(v) => revSetGroupCurrentPage(group.videoId, v)"
                @size-change="(v) => revSetGroupPageSize(group.videoId, v)">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="showRevenueDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="我的邀请链接" :visible.sync="showInviteLinkDialog" width="500px">
      <div v-loading="inviteLoading">
        <p style="margin-bottom:12px;color:#666">用户通过此链接注册后，将自动归入您名下：</p>
        <el-input v-model="inviteLink" readonly>
          <el-button slot="append" icon="el-icon-document-copy" @click="copyInviteLink">复制</el-button>
        </el-input>
      </div>
      <div slot="footer">
        <el-button @click="showInviteLinkDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import UserNode from './UserNode.vue'
function toFixed2(val) {
  if (val == null || val === '') return '0.00'
  const n = parseFloat(val)
  if (isNaN(n)) return '0.00'
  return n.toFixed(2)
}
function toInt(val) {
  if (val == null || val === '') return '0'
  const n = parseFloat(val)
  if (isNaN(n)) return '0'
  return String(Math.floor(n))
}
export default {
  name: 'UserManage',
  components: { UserNode },
  data() {
    return {
      treeData: [],
      loading: false,
      showDialog: false,
      parentId: null,
      parentNickname: '',
      userForm: { username: '', password: '', nickname: '', roleType: 'USER', canImport: 0, incomePermission: 'BOTH', videoIds: [], groupId: null },
      userRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur', min: 6 }],
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        roleType: [{ required: true, message: '请选择角色', trigger: 'change' }]
      },
      videoInputVisible: false,
      videoInputValue: '',
      showEditDialog: false,
      editingUserId: null,
      editForm: { nickname: '', password: '', canImport: 0, incomePermission: 'BOTH', videoIds: [], groupId: null, parentId: null },
      editRules: {
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }]
      },
      editVideoInputVisible: false,
      editVideoInputValue: '',
      editFormRoleType: '',
      parentCandidates: [],
      groupList: [],
      theaterAllList: [],
      showRevenueDialog: false,
      revenueUserName: '',
      revenueSummary: null,
      revenueGroupedData: [],
      revenueGroupDetails: {},
      revenueLoading: false,
      revenueUserId: null,
      revenueExpandedRows: [],
      revGroupPageSizes: {},
      revGroupCurrentPages: {},
      showInviteLinkDialog: false,
      inviteLink: '',
      inviteLoading: false
    }
  },
  computed: {
    ...mapGetters(['isSuperAdmin', 'isSubAdmin']),
    revenueCards() {
      if (!this.revenueSummary) return []
      return [
          { label: '视频播放量', value: String(Math.floor(parseFloat(this.revenueSummary.videoPlayCount || 0))), key: 'videoPlayCount' },
          { label: '剧集播放量', value: String(Math.floor(parseFloat(this.revenueSummary.dramaPlayCount || 0))), key: 'dramaPlayCount' },
          { label: '总收益', value: Number(this.revenueSummary.adIncome || 0).toFixed(2), key: 'adIncome', color: '#667eea' },
          { label: '数据条数', value: String(this.revenueSummary.count || 0), key: 'count' }
        ]
      }
  },
  mounted() {
    this.loadTree()
    api.teamList().then(res => { this.groupList = res.data || [] })
    this.loadTheaters()
  },
  methods: {
    toFixed2,
    toInt,
    loadTheaters() {
      if (this.isSuperAdmin) {
        api.theaterAll().then(res => { this.theaterAllList = res.data || [] })
      } else {
        api.theaterList().then(res => { this.theaterAllList = res.data || [] })
      }
    },
    loadTree() {
      this.loading = true
      api.getUserTree().then(res => { this.treeData = res.data || [] }).finally(() => { this.loading = false })
    },
    openAdd(parentRow) {
      this.parentId = parentRow ? parentRow.id : null
      this.parentNickname = parentRow ? (parentRow.nickname || parentRow.username) : ''
      this.userForm = { username: '', password: '', nickname: '', roleType: 'USER', canImport: 0, incomePermission: 'BOTH', videoIds: [], theaterIds: [], groupId: null }
      this.showDialog = true
    },
    openEdit(row) {
      this.editingUserId = row.id
      this.editFormRoleType = row.roleType || ''
      this.editForm = {
        nickname: row.nickname || row.username,
        password: '',
        canImport: row.canImport || 0,
        incomePermission: row.incomePermission || 'BOTH',
        videoIds: [...(row.boundVideoIds || [])],
        theaterIds: [...(row.boundTheaterIds || [])],
        groupId: row.groupId || null,
        parentId: row.parentId || null
      }
      this.parentCandidates = []
      api.getParentCandidates().then(res => {
        this.parentCandidates = res.data || []
      })
      this.showEditDialog = true
    },
    handleEdit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const payload = { ...this.editForm }
        if (!payload.password) delete payload.password
        if (payload.parentId == null) payload.parentId = 0
        api.updateUser(this.editingUserId, payload).then(() => {
          this.$message.success('修改成功')
          this.showEditDialog = false
          this.editingUserId = null
          this.loadTree()
        })
      })
    },
    handleCreate() {
      this.$refs.userForm.validate(valid => {
        if (!valid) return
        const payload = { ...this.userForm }
        if (this.parentId) {
          payload.parentId = this.parentId
        }
        api.createUser(payload).then(() => {
          this.$message.success('创建成功')
          this.showDialog = false
          this.parentId = null
          this.parentNickname = ''
          this.loadTree()
        })
      })
    },
    handleToggleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      api.updateUserStatus(row.id, newStatus).then(() => {
        this.$message.success('操作成功')
        this.loadTree()
      })
    },
    handleDeleteUser(row) {
      this.$confirm('确认删除用户 "' + (row.nickname || row.username) + '" ?', '提示', { type: 'warning' }).then(() => {
        api.deleteUser(row.id).then(() => {
          this.$message.success('删除成功')
          this.loadTree()
        })
      }).catch(() => {})
    },
    showVideoInput() {
      this.videoInputVisible = true
      this.$nextTick(() => { this.$refs.videoInput && this.$refs.videoInput.focus() })
    },
    addVideo() {
      const val = this.videoInputValue.trim()
      if (!val) {
        this.videoInputVisible = false
        this.videoInputValue = ''
        return
      }
      if (!val.startsWith('sph')) {
        this.$message.warning('视频号ID必须以sph开头')
        this.videoInputValue = ''
        return
      }
      if (val && !this.userForm.videoIds.includes(val)) {
        this.userForm.videoIds.push(val)
      }
      this.videoInputVisible = false
      this.videoInputValue = ''
    },
    removeVideo(idx) {
      this.userForm.videoIds.splice(idx, 1)
    },
    showEditVideoInput() {
      this.editVideoInputVisible = true
      this.$nextTick(() => { this.$refs.editVideoInput && this.$refs.editVideoInput.focus() })
    },
    addEditVideo() {
      const val = this.editVideoInputValue.trim()
      if (!val) {
        this.editVideoInputVisible = false
        this.editVideoInputValue = ''
        return
      }
      if (!val.startsWith('sph')) {
        this.$message.warning('视频号ID必须以sph开头')
        this.editVideoInputValue = ''
        return
      }
      if (val && !this.editForm.videoIds.includes(val)) {
        this.editForm.videoIds.push(val)
      }
      this.editVideoInputVisible = false
      this.editVideoInputValue = ''
    },
    removeEditVideo(idx) {
      this.editForm.videoIds.splice(idx, 1)
    },
    onVideoInput(val) {
      // 只允许字母数字和常用符号，过滤汉字
      this.videoInputValue = val.replace(/[^a-zA-Z0-9_\-]/g, '')
    },
    onEditVideoInput(val) {
      this.editVideoInputValue = val.replace(/[^a-zA-Z0-9_\-]/g, '')
    },
    onCreateGroupChange(val) {
      if (!val) return
      const g = this.groupList.find(g => g.id === val)
      if (g && g.videoIds && g.videoIds.length > 0) {
        const merged = [...new Set([...this.userForm.videoIds, ...g.videoIds])]
        this.userForm.videoIds = merged
      }
    },
    onEditGroupChange(val) {
      if (!val) return
      const g = this.groupList.find(g => g.id === val)
      if (g && g.videoIds && g.videoIds.length > 0) {
        const merged = [...new Set([...this.editForm.videoIds, ...g.videoIds])]
        this.editForm.videoIds = merged
      }
    },
    handleQueryRevenue(row) {
      this.revenueUserName = row.nickname || row.username
      this.revenueUserId = row.id
      this.revenueSummary = null
      this.revenueGroupedData = []
      this.revenueGroupDetails = {}
      this.revenueExpandedRows = []
      this.revGroupPageSizes = {}
      this.revGroupCurrentPages = {}
      this.revenueLoading = true
      this.showRevenueDialog = true
      api.getUserRevenueDashboard(row.id).then(res => {
        this.revenueSummary = res.data.summary || null
        this.revenueGroupedData = res.data.groups || []
      }).finally(() => {
        this.revenueLoading = false
      })
    },
    revToggleExpand(videoId) {
      const index = this.revenueExpandedRows.indexOf(videoId)
      if (index > -1) {
        this.revenueExpandedRows.splice(index, 1)
      } else {
        this.revenueExpandedRows.push(videoId)
        this.loadGroupDetails(videoId)
      }
    },
    revExpandAll() {
      const videoIds = this.revenueGroupedData.map(group => group.videoId).filter(videoId => videoId)
      this.revenueExpandedRows = videoIds
      videoIds.forEach(videoId => this.loadGroupDetails(videoId))
    },
    revCollapseAll() {
      this.revenueExpandedRows = []
    },
    revGetGroupPageSize(videoId) {
      return this.revGroupPageSizes[videoId] || 10
    },
    revSetGroupPageSize(videoId, size) {
      this.$set(this.revGroupPageSizes, videoId, size)
      this.$set(this.revGroupCurrentPages, videoId, 1)
      this.loadGroupDetails(videoId, true)
    },
    revGetGroupCurrentPage(videoId) {
      return this.revGroupCurrentPages[videoId] || 1
    },
    revSetGroupCurrentPage(videoId, page) {
      this.$set(this.revGroupCurrentPages, videoId, page)
      this.loadGroupDetails(videoId, true)
    },
    revGetGroupRecords(videoId) {
      const detail = this.revenueGroupDetails[videoId]
      return detail && detail.records ? detail.records : []
    },
    revIsGroupLoading(videoId) {
      const detail = this.revenueGroupDetails[videoId]
      return !!(detail && detail.loading)
    },
    loadGroupDetails(videoId, forceReload) {
      if (!this.revenueUserId || !videoId) return
      const pageSize = this.revGetGroupPageSize(videoId)
      const pageNum = this.revGetGroupCurrentPage(videoId)
      const cached = this.revenueGroupDetails[videoId]
      if (!forceReload && cached && !cached.loading && cached.pageNum === pageNum && cached.pageSize === pageSize) {
        return
      }
      this.$set(this.revenueGroupDetails, videoId, {
        records: (cached && cached.records) || [],
        loading: true,
        pageNum,
        pageSize
      })
      api.queryUserData(this.revenueUserId, { pageNum, pageSize, videoId }).then(res => {
        const latest = this.revenueGroupDetails[videoId]
        if (!latest || latest.pageNum !== pageNum || latest.pageSize !== pageSize) return
        this.$set(this.revenueGroupDetails, videoId, {
          records: (res.data && res.data.records) || [],
          loading: false,
          pageNum,
          pageSize
        })
      }).catch(() => {
        const latest = this.revenueGroupDetails[videoId]
        if (!latest || latest.pageNum !== pageNum || latest.pageSize !== pageSize) return
        this.$set(this.revenueGroupDetails, videoId, {
          records: [],
          loading: false,
          pageNum,
          pageSize
        })
      })
    },
    showInviteDialog() {
      this.showInviteLinkDialog = true
      this.inviteLoading = true
      api.getInviteCode().then(res => {
        const code = res.data
        this.inviteLink = window.location.origin + '/#/register?invite=' + code
      }).finally(() => {
        this.inviteLoading = false
      })
    },
    copyInviteLink() {
      if (!this.inviteLink) return
      const textarea = document.createElement('textarea')
      textarea.value = this.inviteLink
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('邀请链接已复制到剪贴板')
    }
  }
}
</script>

<style scoped>
.tree-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  margin-bottom: 2px;
  font-size: 12px;
  color: #909399;
  font-weight: 600;
  border-bottom: 1px solid #ebeef5;
}
.tree-header span { flex-shrink: 0; }
.th-icon { width: 24px; }
.th-name { width: 140px; }
.th-tag { width: 100px; }
.th-role { width: 65px; }
.th-perm { width: 130px; }
.th-video { width: 140px; }
.th-time { width: 155px; }

.revenue-section {
  padding: 4px 0;
}

.revenue-header {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
}

.revenue-card {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 8px;
  padding: 16px 12px;
  text-align: center;
  border: 1px solid #e2e8f0;
}

.revenue-card-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
}

.revenue-card-value {
  font-size: 22px;
  font-weight: 700;
  color: #303133;
}

.revenue-tip {
  margin-top: 16px;
  font-size: 12px;
  color: #c0c4cc;
  text-align: center;
}

.form-tip {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.video-group {
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  cursor: pointer;
  transition: all 0.2s ease;
}

.group-header:hover {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
}

.group-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.expand-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s ease;
}

.expand-icon::before,
.expand-icon::after {
  content: '';
  position: absolute;
  background: #6b7280;
  transition: all 0.2s ease;
}

.expand-icon::before {
  width: 12px;
  height: 2px;
  top: 9px;
  left: 4px;
}

.expand-icon::after {
  width: 2px;
  height: 12px;
  top: 4px;
  left: 9px;
}

.expand-icon.expanded::after {
  opacity: 0;
}

.group-video-id {
  font-size: 14px;
  font-weight: 600;
  color: #1e40af;
}

.group-video-nickname {
  font-size: 13px;
  color: #6b7280;
  padding: 2px 8px;
  background: rgba(99, 102, 241, 0.15);
  border-radius: 4px;
}

.group-theaters {
  display: flex;
  gap: 6px;
}

.group-theaters .el-tag {
  background: rgba(148, 163, 184, 0.15);
  border-color: rgba(148, 163, 184, 0.3);
  color: #475569;
}

.group-count {
  font-size: 12px;
  color: #9ca3af;
}

.group-summary {
  display: flex;
  gap: 20px;
}

.summary-item {
  font-size: 13px;
  color: #475569;
}

.summary-item strong {
  color: #1e293b;
  font-weight: 600;
}

.summary-item.income strong {
  color: #6366f1;
}

.group-detail {
  border-top: 1px solid #e2e8f0;
}

.group-detail >>> .el-table thead {
  background: #fafafa;
}

.group-detail >>> .el-table thead th {
  padding: 10px 8px;
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.group-detail >>> .el-table__body tr {
  border-bottom: 1px solid #f1f5f9;
}

.group-detail >>> .el-table__body tr:last-child {
  border-bottom: none;
}

.group-detail >>> .el-table__body tr:hover > td {
  background: #f8fafc;
}

.group-pagination {
  padding: 12px 20px;
  background: #fafafa;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.group-pagination >>> .el-pagination.is-background .el-pager li.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.table-text {
  color: #374151;
  font-size: 13px;
}

.table-number {
  color: #4b5563;
  font-size: 13px;
  font-weight: 500;
}

.table-income {
  color: #1f2937;
  font-size: 13px;
  font-weight: 600;
}
</style>
